webpackJsonp([21733507128203],{

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ectbctb0'
	})('margin-bottom 3rem;');
	
	var Hero = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ectbctb1'
	})(function (props) {
	  return '\n  background-image: url(' + props.src + ');\n  background-position: center center;\n  height: 270px;\n  background-repeat: no-repeat;\n  background-size: cover;\n';
	});
	
	var HeroImage = function HeroImage(props) {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(Hero, { src: props.src, alt: props.alt })
	  );
	};
	
	exports.default = HeroImage;
	module.exports = exports['default'];

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _lodash = __webpack_require__(24);
	
	var _whistle = __webpack_require__(44);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryContainer = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'eko4fiy0'
	})('display:flex;flex-wrap:wrap;padding:1rem;background:#F8F8F8;@media (min-width:800px){display:flex;align-items:center;justify-content:center;padding:2rem;}');
	
	var CategoryTab = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'eko4fiy1'
	})('list-style-type:none;margin-right:.5rem;a{font-size:0.8rem;padding:0.5rem 1rem;}@media (min-width:800px){a{font-size:1rem;padding:1rem;}}');
	
	var renderCategories = function renderCategories(root, categories) {
	  return categories.sort(function (a, b) {
	    return a.totalCount > b.totalCount ? -1 : 1;
	  }).slice(0, 10).map(function (cat, i) {
	    return _react2.default.createElement(
	      CategoryTab,
	      { key: i },
	      _react2.default.createElement(
	        _Button2.default,
	        { flat: true, to: '/' + root + '/' + (0, _whistle.createLink)(cat.fieldValue) + '/' },
	        cat.fieldValue
	      )
	    );
	  });
	};
	
	var filterByCategroy = function filterByCategroy(categories, input) {
	  if (categories && input) {
	    return (0, _lodash.filter)(categories, function (cat) {
	      return cat.description.indexOf(input) > -1 || cat.title.indexOf(input) > -1;
	    });
	  } else {
	    return categories;
	  }
	};
	
	var CategoryList = function (_React$Component) {
	  _inherits(CategoryList, _React$Component);
	
	  function CategoryList(props) {
	    _classCallCheck(this, CategoryList);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      search: ''
	    };
	    return _this;
	  }
	
	  CategoryList.prototype.searchKeyword = function searchKeyword(search) {
	    return this.setState({ search: search });
	  };
	
	  CategoryList.prototype.render = function render() {
	    return _react2.default.createElement(
	      CategoryContainer,
	      null,
	      _react2.default.createElement(
	        CategoryTab,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          { flat: true, to: '/' + this.props.root },
	          'All'
	        )
	      ),
	      renderCategories(this.props.root, filterByCategroy(this.props.categories, this.state.search))
	    );
	  };
	
	  return CategoryList;
	}(_react2.default.Component);
	
	exports.default = CategoryList;
	module.exports = exports['default'];

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _HeroImage = __webpack_require__(282);
	
	var _HeroImage2 = _interopRequireDefault(_HeroImage);
	
	var _categoryList = __webpack_require__(86);
	
	var _categoryList2 = _interopRequireDefault(_categoryList);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _whistle = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1kvo7ss0'
	})('max-width:1000px;margin:0 auto;');
	
	var Container = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1kvo7ss1'
	})();
	
	var Header = /*#__PURE__*/(0, _reactEmotion2.default)('h1', {
	  target: 'e1kvo7ss2'
	})('text-align:left;font-size:2rem;line-height:2.2rem;');
	
	var BlogList = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1kvo7ss3'
	})('flex:1;flex-direction:column;padding:1rem;h1{text-align:left;}h3{text-align:right;}a.tag{padding:4px 10px;background-color:#00B386;color:white;margin:2px;font-size:0.9rem;}.blog-content{p img{max-width:100%;margin:0 auto;display:block;padding:1rem 0;}@media (max-width:800px){p img{width:100%;}}}');
	
	var Row = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1kvo7ss4'
	})('width:100%;flex:1;display:flex;flex-direction:column-reverse;margin-bottom:1rem;@media (min-width:800px){flex-direction:row;}');
	
	var Column = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1kvo7ss5'
	})('display:flex;flex:0.75;flex-flow:wrap;');
	var EndColumn = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1kvo7ss6'
	})('display:flex;flex:0.25;flex-direction:row;justify-content:flex-start;@media (min-width:800px){align-self:center;justify-content:flex-end;}');
	
	var Back = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1kvo7ss7'
	})('border-top:1px solid #F8F8F8;padding:1rem 0;');
	
	var prettyCategories = function prettyCategories(arr) {
	  return arr.map(function (category, i) {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'tag', to: '/news/' + (0, _whistle.createLink)(category) + '/' },
	      category
	    );
	  });
	};
	
	function Template(props) {
	  var data = (0, _whistle.blogFormat)(props.data);
	  var markdownRemark = props.data.markdownRemark; // data.markdownRemark holds our post data
	
	  var frontmatter = markdownRemark.frontmatter;
	
	
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: frontmatter.title,
	      meta: [{ name: 'og:title', content: frontmatter.title }, { name: 'description', content: frontmatter.description }, { name: 'og:description', content: frontmatter.description }, { name: 'og:image', content: frontmatter.hero ? 'https://trywhistle.com/' + frontmatter.hero : '' }, { name: 'og:type', content: "article" }, { name: 'og:locale', content: "en_US" }, { name: 'article:tag', content: frontmatter.categories }]
	    }),
	    _react2.default.createElement(
	      Wrapper,
	      null,
	      frontmatter.hero ? _react2.default.createElement(_HeroImage2.default, {
	        alt: frontmatter.title,
	        src: frontmatter.hero
	      }) : null,
	      _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          BlogList,
	          null,
	          _react2.default.createElement(
	            Header,
	            null,
	            data.title
	          ),
	          _react2.default.createElement(
	            'i',
	            null,
	            data.author
	          ),
	          _react2.default.createElement(
	            Row,
	            null,
	            _react2.default.createElement(
	              Column,
	              null,
	              prettyCategories(data.categories)
	            ),
	            _react2.default.createElement(
	              EndColumn,
	              null,
	              _react2.default.createElement(
	                'h3',
	                null,
	                data.date
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'blog-content', dangerouslySetInnerHTML: { __html: data.html } }),
	          _react2.default.createElement(
	            Back,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/news' },
	              'Back to list'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.addComma = exports.createLink = exports.blogItemFormat = exports.blogFormat = undefined;
	
	var _lodash = __webpack_require__(24);
	
	var blogFormat = exports.blogFormat = function blogFormat(data) {
	  var format = {};
	  if (data) {
	    var markdownRemark = data.markdownRemark;
	
	    format = markdownRemark.frontmatter;
	    format.allCategories = data.categories.group;
	    format.html = markdownRemark.html;
	  }
	  return format;
	};
	
	var blogItemFormat = exports.blogItemFormat = function blogItemFormat(data) {
	  var format = {
	    categories: [],
	    posts: []
	  };
	  if (data && data.posts) {
	    if (data.categories.group) {
	      format.categories = data.categories.group;
	    }
	    if (data.posts.edges.length) format.posts = data.posts.edges.map(function (g) {
	      if (g.node && g.node.fields && g.node.fields.slug) {
	        g.node.frontmatter.slug = g.node.fields.slug;
	      }
	      if (g.node && g.node.frontmatter) {
	        return g.node.frontmatter;
	      }
	      return null;
	    });
	  }
	  return format;
	};
	
	var createLink = exports.createLink = function createLink(value) {
	  var link = "";
	  if (value) {
	    link = value.toLowerCase().split(" ").join("-");
	  }
	  return (0, _lodash.kebabCase)(link);
	};
	
	var addComma = exports.addComma = function addComma(arr, index) {
	  var arrayLength = arr.length;
	  if (arr.length === 1 || arrayLength === index + 1) {
	    return null;
	  }
	  if (arrayLength - 1 === index + 1) {
	    return ' and ';
	  }
	  return ", ";
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-post-js-57f0d8d8e5e988c5ce1f.js